import { toast } from "react-toastify";

const QuantitySelector = ({ 
  quantity, 
  setQuantity, 
  maxStock,
  disabled 
}) => {
  const increaseQuantity = () => {
    if (quantity < maxStock) {
      setQuantity(prev => prev + 1);
    } else {
      toast.info(`Maximum available quantity is ${maxStock}`);
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity(prev => prev - 1);
    }
  };

  return (
    <div className="mb-4">
      {/* <label className="block text-sm font-medium text-gray-700 mb-2">
        Quantity
      </label> */}
      <div className="flex items-center">
        <button
          onClick={decreaseQuantity}
          disabled={quantity <= 1 || disabled}
          className={`w-10 h-10 flex items-center justify-center rounded-l-md border ${
            quantity <= 1 || disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-600 hover:bg-gray-50'
          }`}
        >
          <span className="text-xl">-</span>
        </button>
        <div className={`w-16 h-10 flex items-center justify-center border-t border-b border-gray-300 ${
          disabled ? 'bg-gray-50' : 'bg-white'
        } text-gray-700`}>
          {disabled ? (
            <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-blue-500"></div>
          ) : (
            quantity
          )}
        </div>
        <button
          onClick={increaseQuantity}
          disabled={quantity >= maxStock || disabled}
          className={`w-10 h-10 flex items-center justify-center rounded-r-md border ${
            quantity >= maxStock || disabled ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : 'bg-white text-gray-600 hover:bg-gray-50'
          }`}
        >
          <span className="text-xl">+</span>
        </button>
        {/* <span className="ml-3 text-sm text-gray-500">
          {maxStock} available
        </span> */}
      </div>
    </div>
  );
};

export default QuantitySelector;